/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollectionSubtitleDetail } from '../collection-subtitle-schema';
import { collectionSubtitleDetailSchema } from '../collection-subtitle-schema';

export const collectionSubtitleV2DataSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({ exists: z.literal(true), value: collectionSubtitleDetailSchema }),
]);

export type ICollectionSubtitleV2Data =
  | { exists: false }
  | { exists: true; value: ICollectionSubtitleDetail };

export const getCollectionSubtitleV2ResponseSchema = createApiResponseSchema(
  collectionSubtitleV2DataSchema,
) as import('zod').ZodSchema<IAPI<ICollectionSubtitleV2Data>>;

export type IGetCollectionSubtitleV2Response = IAPI<ICollectionSubtitleV2Data>;
